import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Grid, FormControlLabel, Checkbox } from '@mui/material';
import DonationContext from '../../../../context/DonationContext/DonationContext';
import PickupsFormVariant from './PickupsFormVariant/PickupsFormVariant';
import { donationManageActions } from '../../../../helpers/donations';
import { FREQUENCY_ONCE } from '../../../../models/donationsNew';
import { DONATION_TYPE_REQUEST_APPROVAL, DONATION_TYPE_SD } from '../../../../actions/donationNew';
import GroupsSelector from './Groups/GroupsSelector';
import useHasActiveFeatureFlag from '../../../../hooks/useFeatureFlags';
import { FF_USER_GROUPS } from '../../../../components/FeatureFlagWrapper';

const Pickups = () => {
  const {
    all_days_are_the_same: allDaysTheSame,
    all_pickups_are_the_same: allPickupsTheSame,
    frequency: frequency,
    pickup_specs: pickups,
    groups: donationGroups,
  } = useSelector(state => state.ui.donation_new.draft);
  const diffInflight = useSelector(state => state.ui.donation_new.diffInflight);

  const { onFieldChange, donationType } = useContext(DonationContext);
  const hasUserGroupsFF = useHasActiveFeatureFlag(FF_USER_GROUPS);

  if (!pickups || pickups.length === 0) {
    return null;
  }

  return (
    <Grid container item spacing={2}>
      {hasUserGroupsFF &&
        ([DONATION_TYPE_SD].includes(donationType) ||
          [DONATION_TYPE_SD, DONATION_TYPE_REQUEST_APPROVAL].includes(donationType)) && (
          <Grid item xs={12} md={6}>
            <GroupsSelector
              disabled={diffInflight}
              selectedGroups={donationGroups || []}
              onChange={groups => onFieldChange(donationManageActions.set_group_ids, groups)}
            />
          </Grid>
        )}

      {[DONATION_TYPE_SD].includes(donationType) && frequency === FREQUENCY_ONCE && pickups.length > 1 && (
        <Grid container item xs={12}>
          <Grid item>
            <FormControlLabel
              control={
                <Checkbox
                  disabled={diffInflight}
                  color="secondary"
                  onChange={event => {
                    if (event.target.checked) {
                      return onFieldChange(donationManageActions.set_all_days_are_the_same);
                    }

                    return onFieldChange(donationManageActions.clear_all_pickups_are_the_same);
                  }}
                  name="all_pickups_are_the_same"
                  checked={allPickupsTheSame || false} //fallback for undefined value
                />
              }
              label="All pickups are the same"
            />
          </Grid>
        </Grid>
      )}
      {frequency !== FREQUENCY_ONCE && (
        <Grid container item xs={12}>
          <Grid item>
            <FormControlLabel
              control={
                <Checkbox
                  disabled={diffInflight}
                  color="secondary"
                  onChange={event => {
                    if (event.target.checked) {
                      return onFieldChange(donationManageActions.set_all_days_are_the_same);
                    }
                    return onFieldChange(donationManageActions.clear_all_days_are_the_same);
                  }}
                  name="all_days_are_the_same"
                  checked={allDaysTheSame || false} //fallback for undefined value
                />
              }
              label="All days are the same"
            />
          </Grid>
          {[DONATION_TYPE_SD, DONATION_TYPE_REQUEST_APPROVAL].includes(donationType) && (
            <Grid item>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={diffInflight}
                    color="secondary"
                    onChange={event => {
                      if (event.target.checked) {
                        return onFieldChange(donationManageActions.set_all_pickups_are_the_same);
                      }
                      return onFieldChange(donationManageActions.clear_all_pickups_are_the_same);
                    }}
                    name="all_pickups_are_the_same"
                    checked={allPickupsTheSame || false} //fallback for undefined value
                  />
                }
                label="All pickups are the same"
              />
            </Grid>
          )}
        </Grid>
      )}

      <Grid
        item
        xs={12}
        sx={[
          !(frequency !== FREQUENCY_ONCE && allDaysTheSame) &&
            !(frequency === FREQUENCY_ONCE && allPickupsTheSame) && {
              overflow: 'scroll',
              '&&::-webkit-scrollbar': {
                WebkitAppearance: 'none',
                width: 7,
              },
              '&&::-webkit-scrollbar-thumb': {
                borderRadius: '4px',
                backgroundColor: 'rgba(0, 0, 0, .5)',
                WebkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
              },
            },
        ]}
      >
        <PickupsFormVariant />
      </Grid>
    </Grid>
  );
};

export default Pickups;
